import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import { capitalizeFirstLetter, getRole } from "../../helpers";
import moment from "moment";
import { ModalHeader } from "../Styles/InputStyles";

const ViewCommissionModal = ({
    handleClose,
    selectedData,
    setSelectedStaff,
    setIsDeleteCommissionModal,
    setIsEditCommissionModal,
    setIsPayCommissionModal,
    setIsEditExpense
}) => {

    const [height, setHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Staff Commission</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {capitalizeFirstLetter(selectedData?.data?.name || '')}
                    </span>
                    <span className="text-sm text-gray-600">#{selectedData?.data?.mobile}</span>
                </UserInfo>

            </ProfileSection>

            {/* Staff List */}
            <Content>
                {selectedData?.data?.commission?.length > 0 ? (
                    selectedData.data?.commission?.map((staff, index) => (
                        <PropertyCard key={staff.id || index}>
                            <CardHeader>
                                <div>
                                    <p className="font-medium text-gray-800">{capitalizeFirstLetter(staff.staffName)}</p>
                                    <p className="font-normal text-sm text-gray-500">#{staff.staffMobile}</p>
                                </div>
                                <StatusBadge status={staff.staffRole}>
                                    {getRole(staff.staffRole)}
                                </StatusBadge>

                            </CardHeader>

                            <Divider />

                            <Grid>
                                <FlexCol>
                                    <Label>Commission</Label>
                                    <Value>₹{staff.amount || 0}</Value>
                                </FlexCol>
                                <FlexCol>
                                    <Label>Balance</Label>
                                    <Value>₹{staff.balance || 0}</Value>
                                </FlexCol>
                                {staff.isPaid === 0 ?
                                    <FlexCol>
                                        <Label>Due Date</Label>
                                        <Value>{moment(selectedData?.createdAt).format("DD MMM YYYY")}</Value>
                                    </FlexCol>
                                    :
                                    <FlexCol>
                                        <Label>Paid Date</Label>
                                        <Value>{moment(selectedData?.paidDate).format("DD MMM YYYY")}</Value>
                                    </FlexCol>
                                }

                            </Grid>
                            {staff.isPaid === 0 && (
                                <ActionRow>
                                    <PayButton
                                        onClick={() => {
                                            setIsPayCommissionModal(true);
                                            setSelectedStaff(staff);
                                        }}
                                    >
                                        Mark as Paid
                                    </PayButton>
                                </ActionRow>
                            )}
                        </PropertyCard>
                    ))
                ) : (
                    <EmptyState>No Staff found</EmptyState>
                )}
            </Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative `;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const Grid = tw.div`grid grid-cols-2 gap-4`;
const PropertyCard = tw.div`
  bg-white border border-gray-200 rounded-lg p-4
`;
const CardHeader = tw.div`
  flex justify-between items-start
`;
const Divider = tw.div`h-px bg-gray-200 my-3`;
const Content = tw.div`px-4 py-4 space-y-4 overflow-y-auto`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-sm md:text-base`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const EmptyState = tw.div`
  text-center text-gray-500 text-sm py-10
`; const StatusBadge = tw.span`
  text-xs px-2 py-1 rounded-full
  ${({ status }) =>
        status === "Active"
            ? "bg-green-100 text-green-700"
            : status === "Expiring"
                ? "bg-amber-100 text-amber-700"
                : "bg-gray-100 text-gray-600"}
`;
const ActionRow = tw.div`
  flex justify-end
`;

const PayButton = tw.button`
  bg-primary-color text-white text-sm px-4 py-2 rounded-md
  hover:bg-hover-color transition
`;
export default ViewCommissionModal;